import { render, staticRenderFns } from "./manage-slider.vue?vue&type=template&id=6340d0a9&scoped=true&"
import script from "./manage-slider.vue?vue&type=script&lang=js&"
export * from "./manage-slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6340d0a9",
  null
  
)

export default component.exports